import { NavLink } from 'react-router-dom';
import { House, Storefront, ShoppingBagOpen, Package } from '@phosphor-icons/react';
import { useCart } from '@/context/CartContext';
import { NAV } from '@/constants/testIds';

const items = [
  { to: '/', label: 'Home', icon: House, testid: NAV.mobileHome, end: true },
  { to: '/shop', label: 'Shop', icon: Storefront, testid: NAV.mobileCategories },
  { to: '/track', label: 'Track', icon: Package, testid: NAV.mobileTrack },
];

export default function BottomNav() {
  const { count, setCartOpen } = useCart();
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-white/95 backdrop-blur-xl border-t border-stone-200">
      <div className="grid grid-cols-4">
        {items.map(({ to, label, icon: Icon, testid, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={testid}
            className={({isActive}) => `flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${isActive ? 'text-terracotta-700' : 'text-stone-500'}`}
          >
            {({isActive}) => (
              <>
                <Icon size={22} weight={isActive ? 'duotone' : 'regular'} />
                <span>{label}</span>
              </>
            )}
          </NavLink>
        ))}
        <button
          data-testid={NAV.mobileCart}
          onClick={() => setCartOpen(true)}
          className="relative flex flex-col items-center gap-1 py-2.5 text-[11px] font-medium text-stone-500"
        >
          <ShoppingBagOpen size={22} weight="regular" />
          <span>Cart</span>
          {count > 0 && (
            <span className="absolute top-1 right-[28%] min-w-[18px] h-[18px] px-1 rounded-full bg-terracotta-600 text-white text-[10px] font-bold grid place-items-center">
              {count}
            </span>
          )}
        </button>
      </div>
    </nav>
  );
}
